import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CurrentUserGuard } from '®shared/current-user';

import { ErrorPageComponent } from './error-page';
import { PageNotFoundComponent } from './page-not-found';
import { ItemModeResolverComponent } from './reading-lists/item-view/mode-resolver';
import {
  ListEditLegacyRenavComponent,
  ListModeResolverComponent,
} from './reading-lists/list/mode-resolver';
import { SectionModeResolverComponent } from './reading-lists/section-view/mode-resolver';

export const routes: Routes = [
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorPageComponent,
  },
  {
    path: 'error.html',
    pathMatch: 'full',
    component: ErrorPageComponent,
  },
  {
    path: ':version/:tenantCode',
    resolve: {
      currentUser: CurrentUserGuard,
    },
    children: [
      {
        path: 'lists/:listId/edit',
        pathMatch: 'full',
        component: ListEditLegacyRenavComponent,
      },
      // mode-based routing for lists
      {
        path: 'lists/:listId',
        pathMatch: 'full',
        component: ListModeResolverComponent,
      },
      {
        path: 'lists/:listId/modes/edit',
        loadChildren: () =>
          import('app/reading-lists/list/edit/list-edit.module').then(
            m => m.ListEditModule,
          ),
      },
      // all other modes are variations on List View
      {
        path: 'lists/:listId/modes',
        loadChildren: () =>
          import('app/reading-lists/list/view/list-view.module').then(
            m => m.ListViewModule,
          ),
      },
      // mode-based routing for sections
      {
        path: 'sections/:sectionId',
        pathMatch: 'full',
        component: SectionModeResolverComponent,
      },
      {
        path: 'sections/:sectionId/modes',
        loadChildren: () =>
          import('app/reading-lists/section-view/section-view.module').then(
            m => m.SectionViewModule,
          ),
      },
      // mode-based routing for items
      {
        path: 'items/:itemId',
        pathMatch: 'full',
        component: ItemModeResolverComponent,
      },
      {
        path: 'items/:itemId/modes',
        loadChildren: () =>
          import('app/reading-lists/item-view/item-view.module').then(
            m => m.ItemViewModule,
          ),
      },
    ],
  },
  // Since our URLs will always have a list identified, our base path
  // makes no sense in isolation.
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(
  routes,
);
